import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./sass/app.scss";
import "jquery";
import "./sass/bootstrap/js/bootstrap.min.js";
import "./components/_globals";
import axios from "axios";
window.axios = axios;

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
